import { createNextTableContext } from '@core/table';

export const BranchInspectionsTableContext = createNextTableContext();
